import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledCCheckMarkSVG = styled.svg<IconProps>`
  & .cls-1 {
    fill: none;
  }

  & .cls-2 {
    fill: var(--chatbot-color-primary, #404040);
  }

  &.hover:hover,
  &.active {
    .cls-2 {
      fill: var(--du-color-primary, #128370);
      stroke: var(--du-color-primary, #128370);
      stroke-miterlimit: 10;
    }
  }
`;

const CheckMarkIcon: React.FC<IconProps> = ({ active }) => {
  let activeclass = active ? 'active' : undefined;
  const isTouch = !!('ontouchstart' in window) || window.navigator.maxTouchPoints > 0;
  activeclass = `${activeclass} ${!isTouch ? 'hover' : ''}`;
  return (
    <StyledCCheckMarkSVG
      id='CheckMark-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <path id='Margin' className='cls-1' d='M0,0H32V32H0Z' />
      <path
        id='Path_8884'
        data-name='Path 8884'
        className='cls-2'
        d='M7.866,14.024,4.542,10.7,3.41,11.824,7.866,16.28l9.566-9.566L16.308,5.59Z'
        transform='translate(5.59 5.41)'
      />
    </StyledCCheckMarkSVG>
  );
};

export default CheckMarkIcon;
